<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div class="content">
    <van-tabs v-model="active">
      <van-tab title="车头">
        <div class="vehicle-list">
          <div v-for="item in chetouList" :key="item.id">
            <div class="vehicle-item" @click="chooseActions(item.id,item.bpmStatus,'chetou')">
              <div class="vehicle-item-content">

                <div class="bpm-status" v-if="item.bpmStatus == 1">
                  <van-tag type="danger">未提交</van-tag>
                </div>
                <div class="bpm-status" v-else-if="item.bpmStatus == 2">
                  <van-tag type="warning">审核中</van-tag>
                </div>
                <div class="bpm-status" v-else-if="item.bpmStatus == 3">
                  <van-tag type="primary">审核成功</van-tag>
                </div>

                <div class="vehicle-name">车头号:{{item.chetouhao}}</div>
                <div class="content-item first-item">所属车队:{{item.sscd}}</div>
                <div class="content-item">行驶证有效期:{{item.xingshizhengyxq}}</div>
              </div>
              <p class="vehicle-item-desc">详细信息</p>
            </div>
          </div>
        </div>
        <div>
          <div class="add-chetou-box">
            <van-button round type="info" @click="addchetou" class="addBtn">
              新增车头备案
            </van-button>
            <van-button round type="info" @click="refreshchetou" class="refreshBtn">
              刷新
            </van-button>
          </div>
        </div>


      </van-tab>
      <van-tab title="车挂">
        <div class="vehicle-list">
          <div v-for="item in cheguaList" :key="item.id">
            <div class="vehicle-item" @click="chooseActions(item.id,item.bpmStatus,'chegua')">
              <div class="vehicle-item-content">

                <div class="bpm-status" v-if="item.bpmStatus == 1">
                  <van-tag type="danger">未提交</van-tag>
                </div>
                <div class="bpm-status" v-else-if="item.bpmStatus == 2">
                  <van-tag type="warning">审核中</van-tag>
                </div>
                <div class="bpm-status" v-else-if="item.bpmStatus == 3">
                  <van-tag type="primary">审核成功</van-tag>
                </div>

                <div class="vehicle-name">车挂号:{{item.cheguahao}}</div>
                <div class="content-item first-item">所属车队:{{item.sscd}}</div>
                <div class="content-item">行驶证有效期:{{item.xingshizhengyxq}}</div>
              </div>
              <p class="vehicle-item-desc">详细信息</p>
            </div>
          </div>
        </div>
        <div>
          <div class="add-gua-box">
            <van-button round type="info" @click="addchegua" class="addBtn">
              新增车挂备案
            </van-button>
            <van-button round type="info" @click="refreshchegua" class="refreshBtn">
              刷新
            </van-button>
          </div>
        </div>

      </van-tab>
    </van-tabs>
  </div>
  <van-action-sheet v-model="actionShow" :actions="actions" cancel-text="取消" close-on-click-action @select="onSelect" />

</div>
</template>

<script>
import {
  Dialog,
  Toast
} from 'vant'
import api from '@/fetch/api'
import Nav from "../Public/navTpl.vue"
export default {
  inject: ['reload'],
  components: {
    Nav,
  },
  data() {
    return {
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      chetouList: [],
      cheguaList: [],
      active: this.$route.params.type ? this.$route.params.type : 0,
      actionShow: false,
      actions: [{
        name: '查看'
      }, {
        name: '编辑'
      }, {
        name: '删除'
      }],
      actionId: 0,
      bpmStatus: 1,
    }

  },
  created: function() {
    var that = this;
    var openid = this.$store.state.wx_info.openid;

    that.getChetouList(openid);
    that.getCheguaList(openid);
  },
  methods: {
    getChetouList(openid) {
      var that = this;
      api.getChetouList(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          that.$data.chetouList = resData.data
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            that.$router.push({
              name: 'index'
            })
          });
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');
      });
    },
    refreshchetou() {
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      that.getChetouList(openid);
      setTimeout(() => {
        Toast.clear();
      }, 500);
    },
    getCheguaList(openid) {
      var that = this;
      api.getCheguaList(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          that.$data.cheguaList = resData.data
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            that.$router.push({
              name: 'index'
            })
          });
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');

      });
    },
    refreshchegua() {
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      that.getCheguaList(openid);
      setTimeout(() => {
        Toast.clear();
      }, 500);
    },
    addchetou() {
      var that = this;
      that.$router.push({
        name: 'addchetou'
      })
    },
    addchegua() {
      var that = this;
      that.$router.push({
        name: 'addchegua'
      })
    },
    chooseActions(id, bpmStatus, choseType) {
      var that = this;
      that.$data.actionId = id;
      that.$data.bpmStatus = bpmStatus;
      that.$data.choseType = choseType;
      if (bpmStatus == "1") {
        that.$data.actions = [{
          name: '查看'
        }, {
          name: '编辑'
        }, {
          name: '提交审核'
        }, {
          name: '删除'
        }];
      } else if (bpmStatus == "2") {
        that.$data.actions = [{
          name: '查看'
        }, {
          name: '编辑'
        }];
      } else {
        that.$data.actions = [{
          name: '查看'
        }, {
          name: '编辑'
        }, {
          name: '停用'
        }];
      }
      this.actionShow = true;
    },
    deleteVehicle(actionId, choseType) {
      var that = this;
      if (actionId && choseType) {
        let formData = new FormData();
        formData.append("id", actionId);
        Dialog.confirm({
            message: '是否确认删除',
          })
          .then(() => {
            if (choseType == 'chetou') {
              api.deleteBeianChetou(formData).then(function(res) {
                var resData = JSON.parse(res);
                var resMessage = "";
                if (resData.respCode == "0") {
                  resMessage = '操作成功';
                } else {
                  resMessage = resData.message;
                }

                Dialog.alert({
                  message: resMessage,
                }).then(() => {
                  that.reload();
                });
              }).catch(function(err) {
                console.log(err);
                Toast.fail('连接失败，请刷新页面');
              });
            } else {
              api.deleteBeianChegua(formData).then(function(res) {
                var resData = JSON.parse(res);
                var resMessage = "";
                if (resData.respCode == "0") {
                  resMessage = '操作成功';
                } else {
                  resMessage = resData.message;
                }

                Dialog.alert({
                  message: resMessage,
                }).then(() => {
                  that.reload();
                });
              }).catch(function(err) {
                console.log(err);
                Toast.fail('连接失败，请刷新页面');
              });
            }
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    submitVehicle(actionId, choseType) {
      var that = this;
      if (actionId && choseType) {
        let formData = new FormData();
        formData.append("id", actionId);
        Dialog.confirm({
            message: '是否确认提交审核',
          })
          .then(() => {
            if (choseType == 'chetou') {
              api.submitBeianChetou(formData).then(function(res) {
                var resData = JSON.parse(res);
                var resMessage = "";
                if (resData.respCode == "0") {
                  resMessage = '操作成功';
                } else {
                  resMessage = resData.message;
                }

                Dialog.alert({
                  message: resMessage,
                }).then(() => {
                  that.reload();
                });
              }).catch(function(err) {
                console.log(err);
                Toast.fail('连接失败，请刷新页面');
              });
            } else {
              api.submitBeianChegua(formData).then(function(res) {
                var resData = JSON.parse(res);
                var resMessage = "";
                if (resData.respCode == "0") {
                  resMessage = '操作成功';
                } else {
                  resMessage = resData.message;
                }

                Dialog.alert({
                  message: resMessage,
                }).then(() => {
                  that.reload();
                });
              }).catch(function(err) {
                console.log(err);
                Toast.fail('连接失败，请刷新页面');
              });
            }
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    stopVehicle(actionId, choseType) {
      var that = this;
      if (actionId && choseType) {
        let formData = new FormData();
        formData.append("id", actionId);
        Dialog.confirm({
            message: '是否确认停用',
          })
          .then(() => {
            if (choseType == 'chetou') {
              api.stopBeianChetou(formData).then(function(res) {
                var resData = JSON.parse(res);
                var resMessage = "";
                if (resData.respCode == "0") {
                  resMessage = '操作成功';
                } else {
                  resMessage = resData.message;
                }

                Dialog.alert({
                  message: resMessage,
                }).then(() => {
                  that.reload();
                });
              }).catch(function(err) {
                console.log(err);
                Toast.fail('连接失败，请刷新页面');
              });
            } else {
              api.stopBeianChegua(formData).then(function(res) {
                var resData = JSON.parse(res);
                var resMessage = "";
                if (resData.respCode == "0") {
                  resMessage = '操作成功';
                } else {
                  resMessage = resData.message;
                }

                Dialog.alert({
                  message: resMessage,
                }).then(() => {
                  that.reload();
                });
              }).catch(function(err) {
                console.log(err);
                Toast.fail('连接失败，请刷新页面');
              });
            }
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    onSelect(item) {
      var that = this;
      var actionId = that.$data.actionId;
      var choseType = that.$data.choseType;
      var bpmStatus = that.$data.bpmStatus;
      if (actionId && choseType) {
        if (item.name == '编辑') {

          if(bpmStatus == 3)
          {
            if (choseType == 'chetou') {
              Dialog.confirm({
                  message: '该车头信息已经审核通过，编辑后需要重新审核，是否进行编辑？',
                })
                .then(() => {
                  // on confirm
                  that.$router.push({
                    name: 'editchetou',
                    params: {
                      id: actionId
                    }
                  })
                })
                .catch(() => {
                  // on cancel
                });
            }
            else
            {
              Dialog.confirm({
                  message: '该车挂信息已经审核通过，编辑后需要重新审核，是否进行编辑？',
                })
                .then(() => {
                  // on confirm
                  that.$router.push({
                    name: 'editchegua',
                    params: {
                      id: actionId
                    }
                  })
                })
                .catch(() => {
                  // on cancel
                });
            }

          }
          else
          {
            if (choseType == 'chetou') {
              that.$router.push({
                name: 'editchetou',
                params: {
                  id: actionId
                }
              })
            } else {
              that.$router.push({
                name: 'editchegua',
                params: {
                  id: actionId
                }
              })
            }

          }
        } else if (item.name == '删除') {
          this.deleteVehicle(actionId, choseType)
        } else if (item.name == '提交审核') {
          that.submitVehicle(actionId, choseType)
        } else if (item.name == '停用') {
          this.stopVehicle(actionId, choseType);
        } else {
          if (choseType == 'chetou') {
            that.$router.push({
              name: 'chetoudetail',
              params: {
                id: actionId
              }
            });
          } else {
            that.$router.push({
              name: 'cheguadetail',
              params: {
                id: actionId
              }
            });
          }

        }
      } else {
        Toast('网络异常');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
    margin-top: 3.75rem;
}
.add-chetou-box {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    display: flex;
    gap: 0.5rem;
    .addBtn {
        flex: 1;
    }
    .refreshBtn {
        flex: 1;
        color: #0022ff;
        background-color: #ffeb3b;
        border-color: #ffeb3b;
    }
}
.add-gua-box {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    display: flex;
    gap: 0.5rem;
    .addBtn {
        flex: 1;
    }
    .refreshBtn {
        flex: 1;
        color: #0022ff;
        background-color: #ffeb3b;
        border-color: #ffeb3b;
    }
}

.vehicle-list {
    margin-bottom: 4.75rem;
    .vehicle-item {
        margin: 0 1rem;
        margin-top: 1rem;
        overflow: hidden;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        .vehicle-item-content {
            align-items: center;
            box-sizing: border-box;
            min-height: 84px;
            padding: 1rem;
            color: #323233;
            .vehicle-name {
                font-weight: bold;
                font-size: 1rem;
                line-height: 1;
            }
            .content-item {
                line-height: 2;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 0.875rem;
            }
            .first-item {
                margin-top: 0.625rem;
            }
        }
        .vehicle-item-desc {
            padding: 1rem;
            font-size: 0.875rem;
            border-top: 1px dashed #ebedf0;
        }
    }
}
.bpm-status {
    float: right;
}
</style>
